<template>
  <div class="cooperativegoods">
    <el-form :model="form_data" label-width="110px" ref="form_data" inline size='large'>
      <el-form-item label="商城" prop="platform">
        <el-select v-model="form_data.platform"  
          clearable 
          placeholder="请选择商城">
          <el-option 
            v-for="(item, index) in platform_list" 
            :key="index" 
            :label="item.label" 
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称" prop="goods_name">
        <el-input v-model="form_data.goods_name" clearable placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="商品ID" prop="goods_id">
        <el-input v-model="form_data.goods_id" clearable type='number' placeholder="请输入商品ID"></el-input>
      </el-form-item>
      <el-form-item label="类目">
        <el-cascader
          v-model="categoryData"
          placeholder="请选择商品类目"
          :props="categoryOptions"
          clearable
          filterable
          collapse-tags
          @change="categoryChange"></el-cascader>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 22px">
      <el-button size="medium" type='primary' 
        @click="pageData.page = 1, getData()" style="margin-left: 110px">搜索</el-button>
      <el-button size="medium" @click='clearAll'>重置</el-button>
    </div>
    <el-divider class="self-divider"></el-divider>
    <el-table :data="list_data"
      :header-cell-style="{background: '#f9f9f9', color: '#333', fontSize: '14px', fontWeight: 'normal'}"
      :cell-style="{color:'#666', fontSize: '14px'}">
      <el-table-column label="商城" prop="platform" width="130">
        <template slot-scope="scope">
          <div>{{ platformObj[scope.row.platform] }}</div>
        </template>
      </el-table-column>
      <el-table-column label="商品">
        <template slot-scope="scope">
          <div class="flex-box">
            <img :src="scope.row.goods_img"/>
            <div>
              <el-link class="treatment"
                type="primary" 
                :underline="false"
                :href="scope.row.goods_link"
                target='_blank'>{{ scope.row.goods_name }}</el-link>
              <div>商品ID：{{ scope.row.goods_id }}</div>
              <div>店铺名称：{{ scope.row.store_name }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="类目" width="200">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.smzdm_category_1_name ? scope.row.smzdm_category_1_name : "" }}</span>
            <span v-if="scope.row.smzdm_category_2_name">/{{ scope.row.smzdm_category_2_name }}</span>
            <span v-if="scope.row.smzdm_category_3_name">/{{ scope.row.smzdm_category_3_name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="日常价格" width="140">
        <template slot-scope="scope">
          <div>¥{{ scope.row.daily_price }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button class="btn" size="medium" type="text" @click="gohistory(scope.row)">查看历史合作</el-button>
          <!-- <el-button class="btn" size="medium" type="text" @click="goLoadTask(scope.row)">查看带货达人</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
  </div>
</template>

<script>
import http from '@/utils/http'
import pagePagination from "@/components/page_pagination.vue"
export default {
  name: "cooperativegoods",
  components:{
    pagePagination
  },
  data() {
    return {
      pageData: {
        count: 0,
        page: 1,
        offset: 10
      },
      categoryData: [],
      form_data: {
        platform: "",
        goods_name: "",
        goods_id: ""
      },
      platform_list: [
        { label: "淘宝", value: "taobao" },
        { label: "京东", value: "jingdong" },
        { label: "天猫", value: "tianmao" },
        { label: "苏宁", value: "suning" },
        { label: "考拉", value: "kaola" },
        { label: "抖音小店", value: "douyin" },
        { label: "唯品会", value: "weipinhui" },
        { label: "网易严选", value: "wangyiyanxuan" }
      ],
      platformObj: {
        taobao: "淘宝",
        jingdong: "京东",
        tianmao: "天猫",
        suning: "苏宁",
        kaola: "考拉",
        douyin: "抖音小店",
        weipinhui: "唯品会",
        wangyiyanxuan: "网易严选"
      },
      categoryOptions: [],
      list_data: []
    }
  },
  created() {
    this.categoryOptions = this.getcCategoryList();
    this.getData();
  },
  methods: {
    // 类目
    getcCategoryList() {
      return {
        checkStrictly: true,
        label: "name",
        value: "smgscyid",
        lazy: true,
        expandTrigger:"hover",
        lazyLoad(node, resolve) {
          let { level } = node;
          if (level == 2) {
            resolve(null);
            return false;
          }
          let smgscyid = (node.data && node.data.smgscyid) || "";
          let nodes = [];
          http({
            method: "GET",
            url: "home/SmzdmGoodsCategory/getList",
            params: {
              smgscyid: smgscyid
            }
          })
          .then(res => {
            if (res.code == 1) {
              let level = 1;
              nodes = Array.from(res.data.list).map(item => ({
                name: item.name,
                smgscyid: item.smgscyid,
                level: item.level,
                pid: item.pid,
                leaf: item.level >= 2,
              }));
              resolve(nodes);
            } else {
              resolve(null);
            }
          }).catch(err => {
            resolve(null);
          });
        }
      }
    },
    categoryChange (payload) {
      if (payload.length === 2) {
        this.form_data.smzdm_category_1 = payload[0];
        this.form_data.smzdm_category_2 = payload[1];
      } else if (payload.length === 1) {
        this.form_data.smzdm_category_1 = payload[0];
        this.form_data.smzdm_category_2 = "";
      } else {
        this.form_data.smzdm_category_1 = "";
        this.form_data.smzdm_category_2 = "";
      }
    },
    getData() {
      this
        .$http({
          method: "GET",
          url: "/home/getCooperationCpxGoodsList",
          params: {
            page: this.pageData.page,
            page_size: this.pageData.offset,
            ...this.form_data
          }
        })
        .then(res => {
          if (res.code === 1) {
            this.list_data = res.data.data || [];
            this.pageData.count = res.data.total || 0;
          } else {
            this.list_data = [];
            this.pageData.page = 1;
            this.pageData.count = 0;
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查看历史合作
    gohistory(row) {
      this.$router.push({
        path: "/my/cooperativegoods/cooperativehistory",
        query: {
          goods_id: row.goods_id,
          platform: row.platform
        }
      });
    },
    // 查看带货达人
    goLoadTask(row) {
      this.$router.push({
        path: "/my/loadtask",
        query: {
          goods_id: row.goods_id,
          platform: row.platform
        }
      });
    },
    // 重置 
    clearAll() {
      this.categoryData = [];
      this.form_data.smzdm_category_1 = "";
      this.form_data.smzdm_category_2 = "";
      this.$refs["form_data"].resetFields();
      this.pageData.page = 1;
      this.getData();
    },
    // 分页改变
    pageChange(page, pageSize){
      this.pageData.page = page;
      this.pageData.offset = pageSize;
      this.getData();
    }
  }
}
</script>

<style scoped>
.btn {
  margin: 0;
}
.self-divider {
  margin: 20px 0;
  background-color: #f4f4f4;
}
.flex-box {
  display: flex;
}
.flex-box > img {
  width: 70px;
  height: 70px;
  margin: 8px 14px 0 0;
}
.treatment {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>